import React from 'react';

// HWM-22633: envelope glyph for the Communication column email counter.
const EmailIcon: React.FC<{ size?: number; muted?: boolean }> = ({ size = 16, muted = false }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path
            d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
            stroke={muted ? 'var(--color-neutrals-textGamma)' : 'var(--color-neutrals-textAlpha)'}
            strokeWidth="1.6"
            strokeLinejoin="round"
        />
        <path
            d="m22 6-10 7L2 6"
            stroke={muted ? 'var(--color-neutrals-textGamma)' : 'var(--color-neutrals-textAlpha)'}
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default EmailIcon;
